module.exports = __webpack_public_path__ + "img/logo_bribery_division.3384aee7.png";